import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./DishAddProductModal.module.css";
import { productsActions } from "../../../../store/slices/settings-slices";
import { dishProductsAction } from "../../../../store/slices/dishes-slices";

const DishUpdateProductModal = ({
  setDishProductUpdateOpen,
  productId,
  weight,
  weightNetto,
}) => {
  const [selectedDishProduct, setSelectedDishProduct] = useState(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { productsArray, trigger } = useSelector((store) => store.products);
  const { dishProductsForModalArray } = useSelector(
    (store) => store.dishProducts
  );

  const [localWeight, setLocalWeight] = useState(weight);
  const [localWeightNetto, setLocalWeightNetto] = useState(weightNetto);

  useEffect(() => {
    dispatch(productsActions.getAllProducts());
  }, [trigger, dispatch]);

  useEffect(() => {
    if (productsArray.length > 0 && productId) {
      setSelectedDishProduct(productsArray.find((obj) => obj.id === productId));
      //   setValue("weight", weight);
      //   setValue("weightNetto", weightNetto);
    }
  }, [productsArray, productId]);

  const handleUpdateProductSubmit = async (e, data) => {
    e.preventDefault();
    console.log(data);
    try {
      if (!selectedDishProduct) return;

      const weight = Number(data.weight);
      let weightNetto;

      // Check if user manually entered weightNetto, otherwise auto-calculate
      if (data.weightNetto && Number(data.weightNetto) > 0) {
        weightNetto = Number(data.weightNetto);
      } else {
        // Calculate automatic weightNetto based on the product's own ratio
        const originalWeight = parseFloat(selectedDishProduct.weight) || 0;
        const originalWeightNetto =
          parseFloat(selectedDishProduct.weightNetto) || 0;
        const nettoRatio =
          originalWeight > 0 ? originalWeightNetto / originalWeight : 0;
        weightNetto = Number((weight * nettoRatio).toFixed(2));
      }

      const singleProduct = {
        id: selectedDishProduct.id,
        name: selectedDishProduct.name,
        weight,
        weightNetto,
        cost: Number(((selectedDishProduct.price / 1000) * weight).toFixed(2)),
        energy: Number(
          ((selectedDishProduct.energy * weight) / 100).toFixed(2)
        ),
        fats: Number(((selectedDishProduct.fats * weight) / 100).toFixed(2)),
        proteins: Number(
          ((selectedDishProduct.proteins * weight) / 100).toFixed(2)
        ),
        carbohydrates: Number(
          ((selectedDishProduct.carbohydrates * weight) / 100).toFixed(2)
        ),
      };

      //   dispatch(dishProductsAction.removeDishProductForModal(dishProductId));
      const updatedArrayOfProducts = dishProductsForModalArray.map(
        (product) => {
          if (
            product.productId === singleProduct.id ||
            product.id === singleProduct.id
          ) {
            return singleProduct;
          }
          return product;
        }
      );
      dispatch(
        dishProductsAction.updateDishProductsForModal(updatedArrayOfProducts)
      );
      dispatch(dishProductsAction.changeTrigger());
      setDishProductUpdateOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className={css.overlay}>
      <div className={css.modal}>
        <button
          className={css.closeButton}
          onClick={() => setDishProductUpdateOpen(false)}
        >
          &times;
        </button>
        <h2 className={css.title}>Update product</h2>

        <form className={css.content}>
          <div className={css.inputGroup}>
            <label htmlFor="group">Products</label>
            <h2>
              {selectedDishProduct?.name[currentLanguage] ||
                selectedDishProduct?.name["en"]}
            </h2>
          </div>

          <div className={css.inputGroup}>
            <label htmlFor="weight">{t("Weight")}</label>
            <input
              type="number"
              id="weight"
              onChange={(e) => setLocalWeight(e.target.value)}
              value={localWeight}
            />
          </div>

          <div className={css.inputGroup}>
            <label htmlFor="weightNetto">{t("WeightNetto")}</label>
            <input
              type="number"
              id="weightNetto"
              onChange={(e) => setLocalWeightNetto(e.target.value)}
              value={localWeightNetto}
            />
          </div>

          <div className={css.actions}>
            <button
              type="button"
              className={css.cancelButton}
              onClick={() => setDishProductUpdateOpen(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={css.okButton}
              onClick={(e) =>
                handleUpdateProductSubmit(e, {
                  weight: localWeight,
                  weightNetto: localWeightNetto,
                })
              }
            >
              OK
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export { DishUpdateProductModal };
